// Bloco narrativo "Esse sistema não é apenas economia…" — array de frases
// vindas de generateInsights().

import type { CSSProperties } from "react";

export interface QuoteInsightsBlockProps {
  insights: string[];
  /** Máximo de frases a exibir (default 4). */
  limit?: number;
  className?: string;
  style?: CSSProperties;
}

export function QuoteInsightsBlock({
  insights,
  limit = 4,
  className,
  style,
}: QuoteInsightsBlockProps) {
  const slice = insights.slice(0, limit);
  if (slice.length === 0) return null;

  return (
    <div
      className={className}
      style={{
        borderRadius: "8px",
        border: "1px solid #e5e7eb",
        backgroundColor: "#f8fafc",
        padding: "14px 16px",
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        ...style,
      }}
    >
      {slice.map((text, i) => (
        <p
          key={i}
          style={{
            fontSize: "12px",
            color: "#0f172a",
            lineHeight: 1.5,
            margin: 0,
          }}
        >
          {text}
        </p>
      ))}
    </div>
  );
}
